import { useState } from 'react'

import Autocomplete from 'common/components/autocomplete'
import { SelectValue } from 'common/components/autocomplete/Autocomplete'
import TableLoader from 'common/components/loaders/TableLoader'
import Tags from 'common/components/tags'
import Widget from 'common/components/Widget'
import WidgetHeader from 'common/components/WidgetHeader'

type Props = {
  tags: SelectValue[]
  placeholder: string
  title: string
  subtitle: string
  onAddTag: (tag: string) => void
  onRemoveTag: (tag: string) => void
  onInputChange?: (value: string) => string
  'data-cy': string
  'data-testid': string
  isLoading?: boolean
  maxLengthPerTag?: number
  hasTagButtonLabel?: boolean
  tagButtonLabel?: string
  isFreeText?: boolean
  suggestions?: string[]
  className?: string
  maxTagsNumber?: number
  maxTagsMessage?: string
}
const TagWidget = ({
  title,
  subtitle,
  placeholder,
  tags,
  onAddTag,
  onRemoveTag,
  onInputChange,
  maxLengthPerTag,
  isLoading,
  hasTagButtonLabel,
  tagButtonLabel,
  isFreeText = true,
  suggestions,
  className,
  maxTagsNumber,
  maxTagsMessage,
  'data-cy': dataCy,
  'data-testid': dataTestId,
}: Props) => {
  const [searchValue, setSearchValue] = useState<string | undefined>(undefined)
  const onSearch = (search: string) => {
    setSearchValue(search)
  }

  return (
    <Widget data-cy={dataCy} data-testid={dataTestId} className={className}>
      <WidgetHeader
        title={title}
        subtitle={subtitle}
        actions={
          <div className="inline-flex">
            <Autocomplete
              className="w-60"
              placeholder="Filter"
              data-cy="tag-search"
              data-testid="tag-search"
              options={tags}
              value={
                searchValue
                  ? { value: searchValue, label: searchValue }
                  : undefined
              }
              defaultInputValue={searchValue}
              onSearch={onSearch}
              backspaceRemovesValue={true}
            />
          </div>
        }
      />
      {isLoading ? (
        <TableLoader />
      ) : (
        <Tags
          className="mt-8"
          data-cy="tags"
          data-testid="tags"
          isFreeText={isFreeText}
          suggestions={suggestions}
          onAddClick={onAddTag}
          onRemoveClick={onRemoveTag}
          tags={tags}
          onInputChange={onInputChange}
          placeholder={placeholder}
          searchValue={searchValue}
          maxLength={maxLengthPerTag}
          hasTagButtonLabel={hasTagButtonLabel}
          tagButtonLabel={tagButtonLabel}
          maxTagsMessage={maxTagsMessage}
          maxTagsNumber={maxTagsNumber}
        />
      )}
    </Widget>
  )
}

export default TagWidget
